import apiClient from "../utils/apiClient";

export const getCodigoPaisesLada = async () => {
    try {
      const response = await apiClient.get(`/codigo_pais_lada`);    
      return response?.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };


  export const getActivePDP = async () => {
    try {
      const response = await apiClient.get(`/pasarela/activa`);    
      return response?.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  };